var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.question
      ? _c(
          "div",
          { key: _vm.question.id, staticClass: "slidesSize" },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  {
                    staticClass: "mx-auto centered",
                    attrs: {
                      cols: "12",
                      md: _vm.fullWidthCard ? 12 : 10,
                      lg: _vm.fullWidthCard ? 12 : 8
                    }
                  },
                  [
                    _c(
                      "b-card",
                      { staticClass: "neu-card neu-card-sv" },
                      [
                        _vm._t("title"),
                        _vm._v(" "),
                        _c("h2", [_vm._v(_vm._s(_vm.question.question))]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _vm._t("question"),
                            _vm._v(" "),
                            !_vm.$slots.question
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          {
                                            class: [
                                              _vm.stacked
                                                ? "d-flex justify-content-center"
                                                : ""
                                            ]
                                          },
                                          [
                                            _c("radio-button", {
                                              class: [
                                                _vm.stacked
                                                  ? "text-left mx-auto centered"
                                                  : "mx-auto centered"
                                              ],
                                              staticStyle: {
                                                "box-sizing": "border-box"
                                              },
                                              attrs: {
                                                labelsEnabled:
                                                  _vm.labelsEnabled,
                                                options: _vm.question.answer,
                                                stacked: _vm.stacked
                                              },
                                              model: {
                                                value: _vm.localValue,
                                                callback: function($$v) {
                                                  _vm.localValue = $$v
                                                },
                                                expression: "localValue"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.stacked && !_vm.labelsEnabled
                                      ? _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "subtitle-card",
                                                attrs: {
                                                  cols: "6",
                                                  sm: "6",
                                                  lg: "3"
                                                }
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.leastImportantAnswer
                                                    )
                                                  )
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "float-right subtitle-card ml-auto",
                                                attrs: {
                                                  cols: "6",
                                                  sm: "6",
                                                  lg: "3"
                                                }
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.mostImportantAnswer
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._t("additionalComment"),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _vm.showButton
                                  ? _c(
                                      "b-col",
                                      {
                                        staticClass:
                                          "px-0 pt-1 px-md-5 pt-md-3 float-right m-auto",
                                        attrs: { xs: "12", lg: "8" }
                                      },
                                      [
                                        _c(
                                          "transition",
                                          {
                                            attrs: { name: "fade", appear: "" }
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-primary w-100",
                                                attrs: { type: "button" },
                                                on: {
                                                  "~click": function($event) {
                                                    return _vm.action.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-center"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.questionText)
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "float-right m-auto"
                                                  },
                                                  [
                                                    _c("base-icon", {
                                                      attrs: {
                                                        src:
                                                          "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                                                        color: "white"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          2
                        )
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-124970e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-124970e4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/QuestionCard.vue
// module id = 2490
// module chunks = 6 37 38 58 124 125 126 127 128 129 130 131 132 133 134 135 136 137 138